import { MainLayout } from 'src/pages/MainLayout';
import { CreateInvoiceSheet } from 'src/modals/CreateInvoiceSheet';
import { InvoiceDashboard } from 'src/components/invoices/InvoiceDashboard';

export const InvoiceDashboardPage = () => {
  return (
    <MainLayout>
      <div className="flex flex-row justify-between">
        <h1 className="flex-1 text-3xl font-bold">Invoices</h1>
        <CreateInvoiceSheet />
      </div>
      <InvoiceDashboard />
    </MainLayout>
  );
};
